/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { url } from 'utils/urls';


function preloadImages(sources) {
    sources.forEach(source => {
        if(!!source && source !== 'null') new Image().src = source;
    });
}
function getDataSetImgSources(dataSet) {
    const targetQuestionTypes = ['image1', 'image2'];
    let sources = [];
    for (let questionData of dataSet) {
        sources.push(`${url.image.client}${questionData.background}`);
        if(questionData.question && questionData.question.image) sources.push(`${url.image.client}${questionData.question.image}`);
        sources = questionData.question && targetQuestionTypes.includes(questionData.question.type) ? sources.concat(getQuestionImgSources(questionData.answers)) : sources;
    }
    return sources;
}
function getQuestionImgSources(answers) {
    let sources = [];
    for (let answer of answers) {
        sources.push(`${url.image.client}${answer.image}`);
    }
    return sources;
}
function preloadContentElementsData(contentSettings) {
    let sources = getNestedElementsImgSources(contentSettings).map(source => (`${url.image.client}${source}`));
    preloadImages(sources);
}
function getNestedElementsImgSources(data) {
    let sources = [];
    // we might want to use regex for this check in the future
    let fileTypes = ['.jpg', '.png', '.gif', 'jpg)', 'png)', 'gif)'];
    if (typeof data === 'string' && fileTypes.includes(data.substr(data.length - 4))) {
        sources.push(data);
    } else if (typeof data === 'object' && data !== null) {
        for (let element of Object.values(data)) {
            sources = sources.concat(getNestedElementsImgSources(element));
        }
    }
    return sources;
}



// /* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export function preloadDataImages(dataSet) {
    preloadImages(getDataSetImgSources(dataSet));
}
export function preloadStyleImages(styles) {
    let sources = getNestedElementsImgSources(styles).map(source => (source.substr('url('.length, source.length - 'url('.length - 1)));
    preloadImages(sources);
}
